import client from '../base-api';

const serviceURL = '/unemployed';

const unemployedService = {
    getUnemployedNewAndActive(filterData: any) {
        return client.get(`${serviceURL}/new-and-active`, {params: filterData});
    },
    getUnemployedFinished(filterData: any) {
        return client.get(`${serviceURL}/finished`, {params: filterData});
    },
    getUnemployedPotential(filterData: any) {
        return client.get(`${serviceURL}/potential`, {params: filterData});
    },
    getUnemployedOverview(unemployedId: number) {
        return client.get(`${serviceURL}/overview/${unemployedId}`);
    },
    getUnemployed(unemployedId: number) {
        return client.get(`${serviceURL}/details/${unemployedId}`);
    },
    getNextNumber() {
        return client.get(`${serviceURL}/next-number`);
    },

    postUnemployed(body: any) {
        return client.post(serviceURL, body, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    putUnemployed(body: any, id: number) {
        return client.post(`${serviceURL}/${id}`, body, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    postPotentialUnemployed(body: any) {
        return client.post(`${serviceURL}/potential`, body);
    },
    putPotentialUnemployed(body: any, id: number) {
        return client.put(`${serviceURL}/potential/${id}`, body);
    },
    deleteUnemployed(id: number) {
        return client.put(`${serviceURL}/delete/${id}`);
    },
    documentUpload(id: number, body: any) {
        return client.post(`${serviceURL}/document-upload/${id}`, body, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    // Digital signature
    saveDigitalSignature(data: any) {
        return client.post(`${serviceURL}/digital-signature`, data);
    },

}

export default unemployedService;